import { useInfiniteQuery } from "@tanstack/react-query";
import DesignStatusTable from "components/ui/DesignStatusTable";
import apiClient from "lib/api-client";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDesignDate } from "utils/formatDate";

const DesignStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname.split("/")[2];

  let baseUrl = `/api/v4/import_gati/getGatiImportlogs/${path === "design-update" ? "Import_Upadate_Styles_Form_Gati" : "Import_Styles_Form_Gati"}`;

  const fetchData = async ({ pageParam = 1 }) => {
    const res = await apiClient.get(baseUrl, {
      params: { page: pageParam, limit: 15 },
    });
    return { data: res.data.gatiImportLogs, nextPage: res.data.gatiImportLogs.length ? pageParam + 1 : null };
  };

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: [`gatiImportLogs${path}`],
    queryFn: fetchData,
    getNextPageParam: (lastPage) => lastPage.nextPage,
  });

  const handleClick = (time, count) => {
    let newState = {
      ...location.state,
      name: [`${location?.state?.name[0]?.split(" - ")[0]}`, `${formatDesignDate(time)} (${count})`],
    };
    navigate(`/Setting/${path}/${time}`, { state: newState });
  };

  return (
    <div style={{ marginTop: "15px", marginLeft: "6px", marginRight: "11.5px" }}>
      <DesignStatusTable
        data={data?.pages.flatMap((page) => page.data) || []}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        handleClick={handleClick}
        path={path}
      />
    </div>
  );
};

export default DesignStatus;